import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation changePassword($data: changePasswordInput!) {
    changePassword(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const changePasswordRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.ChangePasswordInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_user/change_password',
  async (params: {data: TYPES.ChangePasswordInput;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.changePassword;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const changePasswordSlice = createSlice({
  name: 'change_password',
  initialState: initialState,
  reducers: {
    changePasswordClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(changePasswordRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(changePasswordRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(changePasswordRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { changePasswordClear } = changePasswordSlice.actions;

export const changePassword = createSelector(
  (state: RootState) => state.systemUser.changePassword.result,
  (state: RootState) => state.systemUser.changePassword.error,
  (state: RootState) => state.systemUser.changePassword.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default changePasswordSlice.reducer;